'use client';

import React, { useRef, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import { AntdRegistry } from '@ant-design/nextjs-registry';
import { cleanupBrowserInjections } from '@/lib/utils';

function ClientLayout({ children }: { children: React.ReactNode }) {
  const rootRef = useRef<HTMLDivElement>(null);
  
  // Browser eklentileri tarafından eklenen DOM özniteliklerini temizle
  useEffect(() => {
    // Hydration tamamlandıktan sonra temizlik işlemini yap
    if (rootRef.current) {
      // Bir mikro gecikme ile çalıştır (hydration sonrası)
      const timer = setTimeout(() => {
        cleanupBrowserInjections(rootRef.current);
      }, 0);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  return (
    <AntdRegistry>
      <div ref={rootRef}>
        <Layout>{children}</Layout>
      </div>
    </AntdRegistry>
  );
}

export default ClientLayout; 